/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import Navbar from "react-bootstrap/Navbar";

import { useIsAuthenticated } from "@azure/msal-react";
import { Login } from "./Login";
import { Logout } from "./Logout";
import { Title3 } from "@fluentui/react-components";


/**
 * Renders the navbar component with a sign in or sign out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {
  const isAuthenticated = useIsAuthenticated();

  const cubeetLogo = "https://cubeetapps.blob.core.windows.net/images/cubeet_logo_transparent.png";

  return (
    <>
      <Navbar 
        style={{ backgroundColor: '#151b2b', position: 'sticky', top: 0, zIndex: 1020 }}
        variant="dark" className="navbarStyle"
      >
        <a className="navbar-brand" href="/">
          <img
            src={cubeetLogo}
            alt="Cubeet Logo"
            style={{ marginLeft: '20px', height: '40px' }} // Adjust size as needed
          />
          <Title3 style={{ marginLeft: '10px' }}>Cubeet App Center</Title3>
        </a>
        <div className="collapse navbar-collapse justify-content-end">
          {isAuthenticated ? <Logout /> : <Login />}
        </div>
      </Navbar>

      <br />
      <br />
      {props.children}
    </>
  );
};